import {
  RTL_TRANSCRIPTION_LANGUAGES,
  RTL_TRANSLATION_LANGUAGES,
  UNSUPPORTED_STREAMING_TRANSCRIPTION_LANGUAGES
} from '../constants'

export function isRTLLanguage(language: string): boolean {
  return (
    RTL_TRANSLATION_LANGUAGES.includes(language) ||
    (!UNSUPPORTED_STREAMING_TRANSCRIPTION_LANGUAGES.includes(language) &&
      RTL_TRANSCRIPTION_LANGUAGES.includes(language))
  )
}
